import { getSurfaceTokens } from './tokens';
import type { Theme } from '@mui/material/styles';

const resolveSurfaceTokens = (theme: Theme): ReturnType<typeof getSurfaceTokens> =>
  getSurfaceTokens(theme.palette.mode);

export const semanticColors = {
  surface: (theme: Theme): string => theme.palette.background.default,
  surfaceSubtle: (theme: Theme): string => theme.palette.background.paper,
  pageBg: (theme: Theme): string => resolveSurfaceTokens(theme).page,
  pageAltBg: (theme: Theme): string => resolveSurfaceTokens(theme).pageAlt,
  pageMutedBg: (theme: Theme): string => resolveSurfaceTokens(theme).pageMuted,
  surfacePaper: (theme: Theme): string => resolveSurfaceTokens(theme).paper,
  border: (theme: Theme): string => theme.palette.divider,
  textPrimary: (theme: Theme): string => theme.palette.text.primary,
  textSecondary: (theme: Theme): string => theme.palette.text.secondary,
  actionHover: (theme: Theme): string => theme.palette.action.hover,
  actionSelected: (theme: Theme): string => theme.palette.action.selected,
  accent: (theme: Theme): string => theme.palette.primary.main,
  accentContrast: (theme: Theme): string => theme.palette.primary.contrastText,
  accentStrong: (theme: Theme): string => theme.palette.primary.dark,
  success: (theme: Theme): string => theme.palette.success.main,
  successStrong: (theme: Theme): string => theme.palette.success.dark,
  warning: (theme: Theme): string => theme.palette.warning.main,
  brown: (theme: Theme): string => theme.palette.brown.main,
  error: (theme: Theme): string => theme.palette.error.main,
  errorStrong: (theme: Theme): string => theme.palette.error.dark,
  info: (theme: Theme): string => theme.palette.info.main,
  successBg: (theme: Theme): string => theme.palette.success.light,
  warningBg: (theme: Theme): string => theme.palette.warning.light,
  errorBg: (theme: Theme): string => theme.palette.error.light,
  infoBg: (theme: Theme): string => theme.palette.info.light,
} as const;

export type SemanticColorKey = keyof typeof semanticColors;

export const resolveSemanticColor = (theme: Theme, key: SemanticColorKey): string =>
  semanticColors[key](theme);

export const resolveContrastText = (theme: Theme, background: string): string =>
  theme.palette.getContrastText(background);

export const isLightTheme = (theme: Theme): boolean => {
  const lightSurfaceTokens = getSurfaceTokens('light');
  return resolveSurfaceTokens(theme).page === lightSurfaceTokens.page;
};
